import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AlertState, ALERT_SLICE } from './alert.state';

const selectFeature = createFeatureSelector<AlertState>(ALERT_SLICE);

export const selectAlerts = createSelector(
  selectFeature,
  (state) => state.alerts
);
